import { NgModule } from '@angular/core';
import { NavItemAdminComponent } from './components';

@NgModule({
    declarations: [],
    imports: [NavItemAdminComponent],
    exports: [NavItemAdminComponent],
})
export class NavItemAdminModule {}
